import { ErrorHandler, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { APP_SETTINGS, AppSettings } from 'src/app.settings';
import { CONSENT_PROVIDER, ConsentProvider, CookieCategory } from './privacy/consent/consent-provider';

@Injectable()
export class LoggingService {
  private readonly appSettings: AppSettings = inject(APP_SETTINGS);
  private readonly consent: ConsentProvider = inject(CONSENT_PROVIDER);
  private readonly router: Router = inject(Router);
  private appInsights?: ApplicationInsights;

  init() {
    if (
      this.consent.hasConsentFor(CookieCategory.Performance) &&
      this.appSettings.Logging.AppInsightsInstrumentationKey
    ) {
      this.loadAppInsights();
    }

    // React to future consent changes (user accepts/withdraws)
    this.consent.consentChanges().subscribe(() => {
      const allowed = this.consent.hasConsentFor(CookieCategory.Performance);
      if (allowed && !this.appInsights && this.appSettings.Logging.AppInsightsInstrumentationKey) {
        this.loadAppInsights();
      } else if (!allowed && this.appInsights) {
        try {
          this.appInsights.unload?.(); // stop sending telemetry if supported
        } catch {
          /* ignore */
        }
        this.appInsights = undefined;
      }
    });
  }

  private loadAppInsights() {
    const angularPlugin = new AngularPlugin();
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: this.appSettings.Logging.AppInsightsInstrumentationKey,
        extensions: [angularPlugin],
        extensionConfig: {
          [angularPlugin.identifier]: {
            router: this.router,
            errorServices: [new ErrorHandler()],
          },
        },
      },
    });
    this.appInsights.loadAppInsights();
  }
}
